import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { ReactComponent as IconMapPin } from "../../../assets/svg/location.svg";

// svg
import { ReactComponent as IconChevronRight } from "../../../assets/svg/chevron-right.svg";
import { Box } from "@mui/material";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={1} square {...props} />
))(({ theme }) => ({
  boxShadow: 3,
  border: "none" /* `1px solid ${theme.palette.divider}` */,
  borderRadius: "8px",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<IconChevronRight stroke={"#000"} width="16px" height="16px" />}
    {...props}
  />
))(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: "#fff",
  flexDirection: "row-reverse",
  padding: "4px 8px 4px 4px",
  minHeight: 0,
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    marginRight: "8px",
    [`&.${accordionSummaryClasses.expanded}`]: {
      transform: "rotate(90deg)",
    },
  },

  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
    margin: 0,
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const AccordionStyled = ({
  title,
  expandedDefault = false,
  component,
  location,
  children,
  displayTitle = true,
}) => {
  const [expanded, setExpanded] = useState(expandedDefault);

  const handleChange = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion expanded={expanded} onChange={handleChange}>
      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            /* alignItems: "center", */
          }}
        >
          {displayTitle ? (
            <Typography textAlign={"center"} mr="16px" fontWeight={600}>
              {title}
            </Typography>
          ) : null}
          {component === "site" && (
            <Box
              sx={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <Box width={"18px"}>
                <IconMapPin fill="#5D5F6A" width={"18px"} height={"18px"} />
              </Box>

              <Typography fontSize={14} fontWeight={400}>
                {location}
              </Typography>
            </Box>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
